import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  featureFamilies,
  rowingDependencies,
} from '../components/marketing/content';
import ModuleExplorer from '../components/marketing/ModuleExplorer';

export default function FeaturesPage() {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="marketing-root"
    >
      <div className="container py-12 space-y-12">
        {/* Header */}
        <section className="marketing-hero marketing-hero--compact">
          <div className="marketing-orb orb-one" />
          <div className="marketing-orb orb-two" />
          <div className="marketing-hero__layout">
            <div>
              <p className="marketing-kicker">Features</p>
              <h1 className="marketing-heading text-4xl font-bold mb-3">Meet Our Modules</h1>
              <p className="marketing-lede">
                Member Nest is built around modules that you can turn on and off as needed. Each module is a collection of features that work together to support a specific area of your club's operations, like events or communications.
              </p>
            </div>
            <div className="marketing-hero__panel">
              <h3 className="marketing-heading text-2xl font-semibold">Explore below</h3>
              <p className="text-gray-600 mt-2">
                Below are all of the modules that make Member Nest a tool clubs love. Payments sit at the core of the app, and everything else is optional, have a look at what else we offer, and it's always growing. We build around what you need, so get in touch!
              </p>
              <div className="marketing-steps">
                {[
                  'General club features',
                  'Club-specific features',
                  'Lifecycle stages for each module',
                ].map((text, idx) => (
                  <div key={text} className="marketing-step">
                    <div className="marketing-step__index">{idx + 1}</div>
                    <p className="text-gray-700">{text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="marketing-section">
          <ModuleExplorer
            families={featureFamilies}
            initialFamilyKey="general"
            initialSelectedKeys={{ general: 'events', rowing: 'boatBooking', sailing: 'learnToSail' }}
            title="Explore the feature set"
            description="Use the tabs and left rail to move between features, then step through each verified workflow on the right."
          />
        </section>

        <section className="marketing-section">
          <div className="marketing-split marketing-split--compact">
            <div>
              <p className="marketing-kicker">For rowing clubs</p>
              <h2 className="marketing-heading text-3xl font-semibold mb-3">
                Specialist rowing workflows, without adding another system
              </h2>
              <p className="marketing-lede" style={{ marginBottom: '1.5rem' }}>
                Boat Booking, Outings, and Learn to Row plug into the same events, payments, communications, and member records your club already uses.
              </p>
              <div className="marketing-preview-surface" style={{ marginTop: '1.25rem' }}>
                <div className="marketing-surface__title">Included alongside rowing</div>
                <div className="marketing-chip-list">
                  {rowingDependencies.map((dependency) => (
                    <span key={dependency} className="marketing-chip">
                      {dependency}
                    </span>
                  ))}
                </div>
              </div>
              <div className="marketing-cta-row">
                <Link to="/pricing" className="button button-primary px-6 py-3">
                  View pricing
                </Link>
                <Link to="/demo" className="button button-secondary px-6 py-3">
                  Book a walkthrough
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </motion.main>
  );
}
